import { RouteObject } from 'react-router-dom';
import Login from './login';
import ErrorPage from '../../error-page';
import React from 'react';
import { PasswordRecovery } from './PasswordRecovery';
import { ChangePassword } from './ChangePassword';

export const LoginRoutes: RouteObject[] = [
  {
    path: '',
    element: <Login />,
    errorElement: <ErrorPage />,
  }, {
    path: 'password-recovery',
    element: <PasswordRecovery />,
  }, {
    path: 'change-password',
    element: <ChangePassword />,
  },
];
